// eslint-disable-next-line vue/multi-word-component-names
<template>
<div class="box-support">
  <div class="support">
    <div class="support-left">
      <commonTitle :commonTitle="commonTitle"/>
      <div class="support-bg">
        <video class="support-pc" :poster="supportImg" ref="chanageVideo" preload="auto" x5-video-player-type="h5" x5-video-player-fullscreen="true" x-webkit-airplay="allow" :src="supportVideo" webkit-playsinline playsinline loop muted autoplay>
          <source :src="supportVideo" type="video/mp4">
        </video>
      </div>
    </div>
    <div class="support-list slidetop detay2" data-scroll data-scroll-call="animateMove">
      <div class="review-btn">
        <span v-for="(item, cindex) in supportData" :class="{active : cindex == activeIndex}" :key="item.id" @click="changeTab(cindex)">{{item.title}}</span>
      </div>
      <div class="support-tab">
        <div class="support-item" v-for="(item1,index) in supportData" :key="index" v-show="index == activeIndex">
          <ul class="support-li">
            <li v-for="(item2) in item1.Partners" :key="item2.id">
              <figure><img :src="item2.thumb" alt=""/></figure>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import commonTitle from '@/components/common/HomeTitle'
export default {
  data () {
    return {
      activeIndex: 0,
      commonTitle: {
        title: '大会支持',
        sen: 'support'
      },
      supportVideo: require('@/assets/images/support.mp4'),
      supportImg: require('@/assets/images/support1.png'),
      supportData: {}
    }
  },
  props: {
    scroll: Object
  },
  methods: {
    changeTab (i) {
      this.activeIndex = i
      setTimeout(() => {
        this.scroll.update()
      }, 400)
    },
    async getSupport () {
      const { data: res } = await this.$http.get('/partners')
      if (res.code === 1) {
        this.supportData = res.data
        setTimeout(() => {
          this.scroll.update()
        }, 400)
      }
    }
  },
  components: {
    commonTitle
  },
  mounted () {
    this.getSupport()
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/home/index.less");
</style>
